import readMore from "../../assets/new-education/read-more.svg";
import startHere from "../../assets/new-education/start-here.svg";
import "./CourseReadMore.css";
import "./index.css";
import { useNavigate } from "react-router-dom";

const CourseReadMore = () => {
  const navigate = useNavigate();
  return (
    <div className="course-read-more">
      <img src={readMore} width={90} height={94} alt="Read More" />
      <div className="course-read-more-bg blue">
        <div>
          Holdundervisning? <br />
          <br /> Læring med andre giver nye perspektiver - tag undervisning i
          klasserum, online eller fysisk med en underviser i Århus eller
          København.
        </div>
        <div
          className="education_course_title_info course-under-text blue"
          onClick={() => navigate("/education/classes")}
        >
          Læs mere
        </div>
      </div>
      <div className="course-read-more-bg brown">
        <div>
          Solo læring? <br /> <br />
          Ønsker du hurtig viden uden specifikke tidspunkter, steder eller
          rækkefølge, så kan du tage modulerne direkte her.
        </div>
        <div
          className="education_course_title_info course-under-text brown"
          onClick={() => navigate("/education/#course-lists")}
        >
          Bare gå igang
        </div>
      </div>
      <img src={startHere} width={90} height={94} alt="Start Here" />
    </div>
  );
};

export default CourseReadMore;
